/*
 * @Author: your name
 * @Date: 2021-02-27 16:09:58
 * @LastEditTime: 2023-03-15 11:31:12
 * @LastEditors: heming 984507092@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /mall-admin-web-master/src/permission.js
 */
import router from "./router";
import store from "./store";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
import { Message } from "element-ui";
import { getToken } from "@/utils/auth"; // 验权
import { formatData } from "@/utils/utils";
const whiteList = ["/login"]; // 不重定向白名单
router.beforeEach((to, from, next) => {
  // debugger;
  NProgress.start();
  if (getToken()) {
    // debugger
    if (to.path === "/login") {
      next({
        path: "/"
      });
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles) {
        store
          .dispatch("GetInfo")
          .then(res => {
            // 获取菜单
            let menus = formatData(res.data);
            // let username = res.data.username;
            store
              .dispatch("GenerateRoutes", {
                menus
              })
              .then(() => {
                // 生成可访问的路由表
                router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
                next({
                  ...to,
                  replace: true
                });
              });
          })
          .catch(err => {
            store.dispatch("FedLogOut").then(() => {
              // Message.error(err || "Verification failed, please login again");
              next({
                path: "/"
              });
            });
          });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/login");
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});



// WEBPACK FOOTER //
// ./src/permission.js